import { jsx as _jsx } from "react/jsx-runtime";
import { SubscriptionDefaultIcon } from "@jti/brand-icons/subscription-default";
import { useTranslations } from "@jti/ui";
import { ItemFlag } from "../../../../components/CartItem/ItemFlag/ItemFlag";
export const SubscriptionItemFlag = ({ className }) => {
    const { __ } = useTranslations();
    return (_jsx(ItemFlag, { icon: SubscriptionDefaultIcon, text: __("cart.cart_item.subscription_information"), className: className }));
};
//# sourceMappingURL=SubscriptionItemFlag.js.map